import React, { useContext, useState } from 'react'
import RtcContext from './RtcContext'
import { IRemoteVideoTrack } from 'agora-rtc-react'
import RemoteVideoMute from './Controls/Remote/RemoteVideoMute'
import RemoteAudioMute from './Controls/Remote/RemoteAudioMute'
import SwapUser from './Controls/SwapUser'
import PropsContext, { UIKitUser } from './PropsContext'
import VideoPlaceholder from './VideoPlaceholder'
import Badge from './Controls/Badge'
import FittedVideo, { VideoLayout } from './FittedVideo'

/**
 * React context to expose user array displayed in the smaller view
 */
const MinVideoView = (props: {
  user: UIKitUser
  /** Geometry of the playing video (see FittedVideo); null while there is none. */
  onVideoLayout?: (layout: VideoLayout | null) => void
}) => {
  const { mediaStore } = useContext(RtcContext)
  const { styleProps, rtcProps } = useContext(PropsContext)
  const { minViewStyles, videoMode, minViewOverlayContainer } = styleProps || {}
  const renderModeProp = videoMode?.min
  const [isShown, setIsShown] = useState(false)
  const { user } = props

  return (
    <div
      style={{
        ...{ display: 'flex', flex: 1 },
        ...minViewStyles
      }}
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
    >
      {user.hasVideo === 1 ? (
        <div
          style={{
            ...{
              display: 'flex',
              flex: 1,
              position: 'relative'
            }
          }}
        >
          <Badge user={user} isMaxView={false} />
          <FittedVideo
            fit={renderModeProp !== undefined ? renderModeProp : 'cover'}
            videoTrack={mediaStore[user.uid].videoTrack as IRemoteVideoTrack}
            onLayout={props.onVideoLayout}
          />
          {isShown && (
            <div
              style={{
                ...{
                  margin: 4,
                  position: 'absolute',
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column'
                },
                ...minViewOverlayContainer
              }}
            >
              {!rtcProps.disableRtm && <RemoteVideoMute UIKitUser={user} />}
              {!rtcProps.disableRtm && <RemoteAudioMute UIKitUser={user} />}
              <SwapUser UIKitUser={user} />
            </div>
          )}
        </div>
      ) : (
        <div style={{ position: 'relative', display: 'flex', flex: 1 }}>
          <Badge user={user} isMaxView={false} />
          <VideoPlaceholder
            user={user}
            isShown={isShown}
            showButtons
            showSwap
          />
        </div>
      )}
    </div>
  )
}

export default MinVideoView
